export default __webpack_public_path__ + "static/media/955a7d3279e5f75f4d8db605962c4a851600270598971.1fbefda2.webp";